import React, { useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom"; 
import styled from "styled-components";
import { baseUrl } from "../config";

const ResetPasswordForm = () => {
  const [searchParams] = useSearchParams();
  // Email historically used ?token=; webapp expects ?resetToken= — accept both.
  const resetToken =
    searchParams.get("resetToken") || searchParams.get("token");
  const [newPassword, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (newPassword !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    try {
      await axios.post(baseUrl + "/reset-password", {
        resetToken: resetToken,
        newPassword: newPassword,
      });
      setMessage("Votre mot de passe a été réinitialisé avec succès.");
    } catch (err) {
      setError("Erreur lors de la réinitialisation: " + err.response.data.error || "Veuillez réessayer plus tard.");
    }
  };

  return (
    <FormContainer>
      <h2>Réinitialiser votre mot de passe</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Nouveau mot de passe :
          <input
            type="password"
            name="password"
            value={newPassword}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        <label>
          Confirmer le mot de passe :
          <input
            type="password"
            name="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </label>
        <button type="submit">Valider</button>
      </form>
      {message && <SuccessText>{message}</SuccessText>}
      {error && <ErrorText>{error}</ErrorText>}
    </FormContainer>
  );
};

const FormContainer = styled.div`
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface-2);

  h2 {
    margin-bottom: 20px;
  }

  label {
    display: block;
    margin-bottom: 10px;

    input {
      width: 100%;
      padding: 8px;
      margin-top: 5px;
    }
  }

  button {
    margin-top: 20px;
    padding: 10px 20px;
    background-color: var(--accent);
    color: #13110e;
    border: 1px solid var(--accent);
    border-radius: var(--radius-md);
    cursor: pointer;

    &:hover {
      background-color: var(--accent-hover);
      border-color: var(--accent-hover);
      box-shadow: 0 0 0 3px var(--accent-bg);
    }
  }
`;

const ErrorText = styled.p`
  margin-top: 10px;
  color: red;
`;

const SuccessText = styled.p`
  margin-top: 10px;
  color: green;
`;

export default ResetPasswordForm;
